import React from "react";
import { useTheme } from "@mui/material/styles";

const CorrectIcon = () => {
  const theme = useTheme();

  return (
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="42" viewBox="0 0 24 42" fill="none">
  <path d="M7.75 20.9999L10.58 23.8299L16.25 18.1699" stroke="#0D0D0D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
  );
};

export default CorrectIcon;
